import store from '@/store'
import { MESSAGE_BACKEND_TAGS } from '@/constants/message';

const messagePostProcess = (text) => {
    const configs = [
        store.state.appConfig.appConfig.game_config,
        store.state.appConfig.appConfig.ticket_config,
        store.state.appConfig.appConfig.ticket_config.attachments
    ]
    let result = replaceBackendMarkdown(text)
    configs.forEach(config => result = addConfigValues(result, config))
    return result
}

const replaceBackendMarkdown = (text) => {
    let result = text
    Object.keys(MESSAGE_BACKEND_TAGS).forEach(tag => {
        result = result.replace(new RegExp(`{${tag}}`, 'g'), MESSAGE_BACKEND_TAGS[tag])
    })
    return result
}

const addConfigValues = (text, config) => {
    let result = text
    Object.keys(config).forEach(configParam => {
        result = result.replace(new RegExp(`{${configParam}}`, 'g'), config[configParam])
    })
    return result
}

export default messagePostProcess
